import React from "react"

import styles from "./AvailableFilterList.module.css"

import MenuItem from "~/common/MenuItem"
import * as icons from "~/common/react-icons"

import type { FilterSetWithIcon } from "./types"

type PresetFilterListItemProps = {
  filterSet: FilterSetWithIcon
  onClick: (filterSet: FilterSetWithIcon) => void
}

const PresetFilterListItem = (props: PresetFilterListItemProps) => {
  const { filterSet, onClick } = props

  const handleClick = () => {
    onClick(filterSet)
  }

  return (
    <MenuItem
      text={<div className={styles.filterItem}>{filterSet.name}</div>}
      icon={
        <div className={styles.icon}>
          {filterSet.icon || <icons.BookmarkFilled color="var(--midnight)" />}
        </div>
      }
      onClick={handleClick}
      data-component="PresetFilterListItem"
    />
  )
}

type PresetFilterListProps = {
  presetFilterSets: FilterSetWithIcon[]
  onClick: (filterSet: FilterSetWithIcon) => void
}

const PresetFilterList = (props: PresetFilterListProps) => {
  const { presetFilterSets, onClick } = props

  if (presetFilterSets.length === 0) {
    return null
  }

  return (
    <>
      {presetFilterSets.map((filterSet) => (
        <PresetFilterListItem
          key={filterSet.name}
          filterSet={filterSet}
          onClick={onClick}
        />
      ))}
    </>
  )
}

export default PresetFilterList
